import { render } from "./start-1.vue?vue&type=template&id=c55b33f4&scoped=true"
import script from "./start-1.vue?vue&type=script&lang=js"
export * from "./start-1.vue?vue&type=script&lang=js"

import "./start-1.vue?vue&type=style&index=0&id=c55b33f4&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55b33f4"]])

export default __exports__